import { useEffect, useState } from 'react'

/**
 * Tailwind's `xl` breakpoint (tailwind.config.js `screens.xl`). Keep the two
 * in sync: the dashboard uses this to decide whether the My Tasks widget lives
 * in the right column or behind a tab, and the CSS must agree.
 */
export const XL_QUERY = '(min-width: 1380px)'

const getMatch = (query) => {
    try {
        return typeof window !== 'undefined' && !!window.matchMedia?.(query)?.matches
    } catch (e) {
        return false
    }
}

/**
 * Subscribes to a CSS media query. The initial value is read synchronously so
 * the first render is already correct (no wrong-first-frame layout swap).
 * Safe in non-browser environments, where it always returns false.
 */
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => getMatch(query))

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined
        const mql = window.matchMedia(query)
        const onChange = (event) => setMatches(event.matches)
        setMatches(mql.matches)
        if (mql.addEventListener) {
            mql.addEventListener('change', onChange)
            return () => mql.removeEventListener('change', onChange)
        }
        // Safari < 14
        mql.addListener(onChange)
        return () => mql.removeListener(onChange)
    }, [query])

    return matches
}
